export const sxStyle = {
  root: {
    height: '111vh',
    bgcolor: 'rgba(0, 0, 0, 0.1)',
  },
  container: {
    width: { xs: '95%', sm: '50%' },
    display: { xs: 'flex', sm: 'initial' },
    alignItems: { xs: 'center', sm: 'initial' },
  },
  formContainer: {
    padding: '32px',
  },
  title: {
    fontSize: { xs: '20px', md: '25px' },
  },
  subtitle: {
    fontSize: { xs: '14px', md: '18px' },
  },
};
